
import React from 'react';
import { CheckCircle, TrendingUp, Scale, Recycle } from 'lucide-react';

const ValoGuideNews = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <header className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <TrendingUp className="w-8 h-8 text-fabre-green mr-3" />
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-fabre-gray">
                Actualités et Innovations
              </h2>
            </div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Restez informé des dernières évolutions dans le domaine de l'environnement et du recyclage
            </p>
          </header>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <article className="bg-gradient-to-br from-fabre-lightbeige to-white p-6 rounded-lg border shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <Recycle className="w-6 h-6 text-fabre-green mr-2" />
                <h3 className="text-xl font-heading font-bold text-fabre-gray">
                  Technologies de Recyclage
                </h3>
              </div>
              <p className="text-gray-600 mb-4">
                Découvrez les innovations technologiques qui révolutionnent 
                le tri et la valorisation des déchets.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Intelligence artificielle pour le tri
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Robotique industrielle
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Traçabilité numérique
                </li>
              </ul>
            </article>

            <article className="bg-gradient-to-br from-fabre-lightbeige to-white p-6 rounded-lg border shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <Scale className="w-6 h-6 text-fabre-green mr-2" />
                <h3 className="text-xl font-heading font-bold text-fabre-gray">
                  Réglementation
                </h3>
              </div>
              <p className="text-gray-600 mb-4">
                Les évolutions réglementaires importantes pour 
                la gestion des déchets d'entreprise.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Loi AGEC et économie circulaire
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Obligations de tri 5 flux
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Responsabilité élargie producteur
                </li>
              </ul>
            </article>

            <article className="bg-gradient-to-br from-fabre-lightbeige to-white p-6 rounded-lg border shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <TrendingUp className="w-6 h-6 text-fabre-green mr-2" />
                <h3 className="text-xl font-heading font-bold text-fabre-gray">
                  Marchés des Matières
                </h3>
              </div>
              <p className="text-gray-600 mb-4">
                Tendances et évolutions des cours des matières premières 
                issues du recyclage.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Cours des métaux ferreux
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Valorisation aluminium et cuivre
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-4 h-4 text-fabre-green mt-0.5 mr-2 flex-shrink-0" />
                  Marché papiers-cartons
                </li>
              </ul>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValoGuideNews;
